import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CharacteristicObject } from 'src/app/models/characteristics/characteristic/characteristic-object.model';

@Component({
  selector: 'app-input-characteristics-panel',
  templateUrl: './input-characteristics-panel.component.html',
  styleUrls: ['./input-characteristics-panel.component.css']
})
export class InputCharacteristicsPanelComponent implements OnInit {

  @Input() characteristics: Array<CharacteristicObject>;
  @Input() editable: boolean;
  @Output() expandEvent = new EventEmitter();
  @Output() diffCharacteristicsEvent = new EventEmitter();

  @Input() expanded: boolean;

  constructor() {

  }

  ngOnInit() {
  }

  public expand($event: boolean) {
    this.expandEvent.emit($event);
  }

  onDiffCharacteristics($event) {
    this.diffCharacteristicsEvent.emit($event);
  }

}
